export function percentChange(previous, current) {
    if (previous === 0)
        return 0;
    var change = ((current - previous) / previous) * 100;
    return Number(change.toFixed(2));
}
export function formatCompactNumber(value, digits) {
    if (digits === void 0) { digits = 2; }
    if (!Number.isFinite(value))
        return "0";
    if (value === 0)
        return "0";
    var sign = value < 0 ? "-" : "";
    var abs = Math.abs(value);
    var units = [
        { v: 1e12, s: "T" },
        { v: 1e9, s: "B" },
        { v: 1e6, s: "M" },
        { v: 1e3, s: "K" },
    ];
    var floorTo = function (num, d) {
        var p = Math.pow(10, d);
        return Math.floor(num * p) / p;
    };
    for (var _i = 0, units_1 = units; _i < units_1.length; _i++) {
        var u = units_1[_i];
        if (abs >= u.v) {
            var num = abs / u.v;
            var floored = floorTo(num, digits);
            return "".concat(sign).concat(floored).concat(u.s);
        }
    }
    var flooredSmall = floorTo(abs, digits);
    if (flooredSmall === 0)
        return "0";
    return "".concat(sign).concat(flooredSmall);
}
